"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var MobileIcon =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(MobileIcon, _PureComponent);

  function MobileIcon() {
    _classCallCheck(this, MobileIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(MobileIcon).apply(this, arguments));
  }

  _createClass(MobileIcon, [{
    key: "render",
    value: function render() {
      var style = {
        fill: this.props.color || '#600460'
      };
      return _react2.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 14 22",
        style: style
      }, _react2.default.createElement("g", {
        id: "prefix__phone_android-24px",
        transform: "translate(-5 -1)"
      }, _react2.default.createElement("path", {
        id: "prefix__Path_1593",
        d: "M7 4h10v14H7z",
        "data-name": "Path 1593",
        style: {
          opacity: .3,
          fill: '#600060'
        }
      }), _react2.default.createElement("path", {
        id: "prefix__Path_1594",
        d: "M16 1H8a2.946 2.946 0 0 0-3 3v16a2.946 2.946 0 0 0 3 3h8a2.946 2.946 0 0 0 3-3V4a2.946 2.946 0 0 0-3-3zm-2 20h-4v-1h4zm3-3H7V4h10z",
        "data-name": "Path 1594",
        style: style
      })));
    }
  }]);

  return MobileIcon;
}(_react.PureComponent);

exports.default = MobileIcon;